import { createSlice } from '@reduxjs/toolkit';
import { API } from 'api';
import { getUIVersion } from 'utils/router-static-data';

const GET_SIGNED_URL_ENDPOINT = '/get-signed-url';

const initialState = {};

export const vendorBillSlice = createSlice({
	name: 'vendorBillState',
	initialState,
	reducers: {},
});
const generate_report = '/generate-report';

const buildGenerateReportCredentials = ({ data, setErrors }) => {
	const isV2UI = getUIVersion() === 'new';

	return {
		url: generate_report,
		data,
		setErrors,
		aclBlockApiCall: false,
		...(isV2UI && { version: 'v2' }),
	};
};

export const getListofInvoice =
	({ search_type = 'vendor_bill_trip', currentPage, ...rest }) =>
	async () => {
		console.log(rest);
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				filter_by: rest?.data,
			},
		};

		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data,
			count: response?.meta?.count,
		}));
	};

export const createVendorBill =
	({ data, setErrors }) =>
	async () => {
		console.log('data', data);
		console.log('setErrors', setErrors);
		const url = '/create';

		const CREDENTIALS = {
			url,
			data,
			setErrors,
		};

		return API.common(CREDENTIALS).then((res) => res);
	};

export const updateVendorBill =
	({ data, setErrors }) =>
	async () => {
		console.log('data', data);
		console.log('setErrors', setErrors);
		const url = '/update';

		const CREDENTIALS = {
			url,
			data,
			setErrors,
		};

		return API.common(CREDENTIALS).then((res) => res);
	};

export const getPDF =
	({ id, setErrors }) =>
	async () => {
		console.log('data', id);
		console.log('setErrors', setErrors);

		const apiData = {
			report_type: 'vendor_bill',
			file_type: 'pdf',
			data: {
				id,
				url_type: 'download',
			},
		};

		const CREDENTIALS = buildGenerateReportCredentials({
			data: apiData,
			setErrors,
		});

		return API.common(CREDENTIALS).then((res) => {
			console.log(res);
			window.open(res?.data?.download_url);
		});
	};
export const getVRF =
	({ id, type, setErrors }) =>
	async () => {
		const apiData = {
			report_type: 'vendor_registration_form',
			file_type: 'file',
			data: {
				id,
				url_type: 'download',
				doc_type: type,
			},
		};

		const CREDENTIALS = {
			url: generate_report,
			data: apiData,
			setErrors,
			aclBlockApiCall: false,
		};

		return API.common(CREDENTIALS).then((res) => {
			console.log(res);
			window.open(res?.data?.download_url);
		});
	};

export const getCSV =
	({ id, setErrors }) =>
	async () => {
		console.log('data', id);
		console.log('setErrors', setErrors);

		const apiData = {
			report_type: 'vendor_bill',
			file_type: 'csv',
			data: {
				id,
				url_type: 'download',
			},
		};

		const CREDENTIALS = buildGenerateReportCredentials({
			data: apiData,
			setErrors,
		});

		return API.common(CREDENTIALS).then((res) => {
			console.log(res);
			window.open(res?.data?.download_url);
		});
	};

export const getVCF =
	({ id, type, setErrors }) =>
	async () => {
		const apiData = {
			report_type: 'vendor_contract_file',
			file_type: 'file',
			data: {
				id,
				url_type: 'download',
				doc_type: type,
			},
		};

		const CREDENTIALS = buildGenerateReportCredentials({
			data: apiData,
			setErrors,
		});

		return API.common(CREDENTIALS).then((res) => {
			window.open(res?.data?.download_url);
		});
	};
export const getSampleDownload = () => {
	const url = GET_SIGNED_URL_ENDPOINT;
	const isV2UI = getUIVersion() === 'new';

	const sampleFileKey = isV2UI
		? 'trip_csv_bulk_upload_sample_file_v2.csv'
		: 'trip_csv_bulk_upload_sample_file.csv';

	const apiData = {
		url_type: 'download',
		data: {
			entity: 'trip_bulk_upload',
			keys: [sampleFileKey],
		},
	};

	const CREDENTIALS = {
		url,
		data: apiData,
		aclBlockApiCall: false,
	};

	return API.common(CREDENTIALS).then((res) => {
		console.log(res);
		window.open(res?.data[0]?.url);
	});
};
export const getAirSampleDownload = () => {
	const url = GET_SIGNED_URL_ENDPOINT;

	const apiData = {
		url_type: 'download',
		data: {
			entity: 'awb_bulk_upload',
			keys: ['6797b905-ddc8-4dc0-8100-caef4ac73930-AWB_SAMPLE_FILE.csv'],
		},
	};

	const CREDENTIALS = {
		url,
		data: apiData,
		aclBlockApiCall: false,
	};

	return API.common(CREDENTIALS).then((res) => {
		console.log(res);
		window.open(res?.data[0]?.url);
	});
};

export const bulkUploadApi =
	({ data_key, setErrors }) =>
	async () => {
		const isV2UI = getUIVersion() === 'new';
		console.log('setErrors', data_key);
		const url = '/bulk-upload';

		const apiData = {
			upload_type: 'trip',
			data: {
				key: data_key,
			},
		};

		const CREDENTIALS = {
			url,
			data: apiData,
			setErrors,
			aclBlockApiCall: false,
			...(isV2UI && { version: 'v2' }),
		};

		return API.common(CREDENTIALS).then((response) => ({
			data: response?.data,
		}));
	};

// Download the invoice-payment bulk-upload sample CSV (headers only).
export const getInvoicePaymentSampleDownload = () => {
	const url = GET_SIGNED_URL_ENDPOINT;

	const apiData = {
		url_type: 'download',
		data: {
			entity: 'invoice_payment_bulk_upload_v2',
			keys: ['invoice_payment_bulk_upload_sample_file_v2.csv'],
		},
	};

	const CREDENTIALS = {
		url,
		data: apiData,
		aclBlockApiCall: false,
	};

	return API.common(CREDENTIALS).then((res) => {
		window.open(res?.data[0]?.url);
	});
};

// Mark vendor-invoice payments in bulk from an uploaded CSV (V2 only).
export const bulkUploadInvoicePaymentApi =
	({ data_key, setErrors }) =>
	async () => {
		const url = '/bulk-upload';

		const apiData = {
			upload_type: 'invoice_payment',
			data: {
				key: data_key,
			},
		};

		const CREDENTIALS = {
			url,
			data: apiData,
			setErrors,
			aclBlockApiCall: false,
			version: 'v2',
		};

		return API.common(CREDENTIALS).then((response) => ({
			data: response?.data,
		}));
	};

export const getVendorInvoiceTrips =
	({ search_type = 'vendor_invoice_trips', limit = 10, offset = 0, ...rest }) =>
	async () => {
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				filter_by: { ...rest },
				limit,
				offset,
			},
		};

		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data || [],
			count: response?.meta?.count || 0,
		}));
	};

export const exportVendorInvoiceTrips =
	({ id }) =>
	async () => {
		const apiData = {
			report_type: 'vendor_invoice_trips_export',
			file_type: 'csv',
			data: {
				id,
				url_type: 'download',
			},
		};

		const CREDENTIALS = {
			url: generate_report,
			data: apiData,
			aclBlockApiCall: false,
		};

		return API.common(CREDENTIALS).then((response) => {
			console.log('Export response:', response);
			if (response?.data?.download_url) {
				window.open(response.data.download_url);
			} else {
				console.error('No download URL in response');
			}
			return response;
		});
	};

/**
 * Get Vendor Bill Edit History V1
 * POST /api/search  { search_type: 'vendor_bill_edit_history', filter_by: { id: <id> } }
 */
export const getVendorBillEditHistory =
	({ id }) =>
	async () => {
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type: 'vendor_bill_edit_history',
				filter_by: {
					id,
				},
			},
		};

		return API.common(CREDENTIALS).then((response) => ({
			data: response?.data || [],
			rows: response?.data || [],
			meta: response?.meta || {},
		}));
	};

/**
 * Get Vendor Bill Payment History V1
 * POST /api/search  { search_type: 'vendor_bill_payment_history', filter_by: { id: <id> } }
 */
export const getVendorBillPaymentHistory =
	({ id }) =>
	async () => {
		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type: 'vendor_bill_payment_history',
				filter_by: {
					id,
				},
			},
		};

		return API.common(CREDENTIALS).then((response) => ({
			data: response?.data || [],
			rows: response?.data || [],
			meta: response?.meta || {},
		}));
	};

/**
 * Update Vendor Bill Charges V1
 * POST /api/update  { update_type: 'vendor_bill_charges', data: { id, charges: {...}, tds_files: [...] } }
 */
export const updateVendorBillCharges =
	({ data, setErrors }) =>
	async () => {
		const CREDENTIALS = {
			url: '/update',
			data,
			setErrors,
		};

		return API.common(CREDENTIALS).then((res) => res);
	};

export default vendorBillSlice.reducer;
